<template>
    <v-card color="grey lighten-2">
        <v-toolbar dense dark color="teal darken-3">
            <v-toolbar-title>Funciones - {{ companyName }} &nbsp;&nbsp;</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn text @click="onClose" v-on="on">
                            <v-icon>cancel</v-icon>
                        </v-btn>
                    </template>
                    <span>Cancelar</span>
                </v-tooltip>
            </v-toolbar-items>

            <!-- Menú lateral para dispositivos con ventanas chicas: -->
            <v-menu offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" class="hidden-md-and-up">
                        <v-icon>more_vert</v-icon>
                    </v-btn>
                </template>
                <v-list color="grey lighten-5">
                    <v-list-item @click="onClose">
                        <v-list-item-title>
                            <v-icon color="teal darken-1">close</v-icon>&nbsp; Cancelar
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-toolbar>

        <!-- Container para lista de Funciones y Función seleccionada: -->
        <v-container pa-2 grid-list-xs>
            <v-layout row>
                <v-flex xs12>
                    <v-radio-group row v-model="functionType" :mandatory="true">
                        <v-radio
                            label="Funciones Primarias"
                            value="1"
                            color="orange accent-4"
                            @change="onPrimaryFunctions"
                        ></v-radio>
                        <v-radio
                            label="Especializadas"
                            value="2"
                            color="orange accent-4"
                            @change="onSpecializedFunctions"
                            :disabled="!thereAreSpecializedFunctionsVal"
                        ></v-radio>
                        <v-radio
                            label="Desagregadas"
                            value="3"
                            color="orange accent-4"
                            @change="onDisaggregatedFunctions"
                            :disabled="(functionType === '1') || (!thereAreDisaggregatedFunctionsVal)"
                        ></v-radio>
                    </v-radio-group>
                </v-flex>
            </v-layout>
            <v-layout row justify-space-around>
                <v-flex xs4 md2>
                    <v-card>
                        <v-toolbar dense color="teal darken-1" dark flat>
                            <v-toolbar-title class="my-list-title">Primarias</v-toolbar-title>
                        </v-toolbar>
                        <v-list
                            subheader
                            dense
                            style="height: 341px; max-height:100%"
                            class="overflow-y-auto"
                            color="grey lighten-5"
                            :disabled="functionType !== '1'"
                        >
                            <v-list-item-group
                                v-model="selectedPrimaryValIndex"
                                color="orange accent-4"
                                mandatory
                            >
                                <v-list-item
                                    class="my-list-item"
                                    v-for="(funct, i) in primaryFunctionsVal"
                                    :key="i"
                                    @click="selectPrimary(funct.funcionesid)"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <v-container pa-0 fluid>
                                                <v-layout row wrap>
                                                    <v-flex md2 xs6>{{ funct.funcion }}</v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-card>
                </v-flex>

                <v-flex xs4 md2>
                    <v-card>
                        <v-toolbar dense color="teal darken-1" dark flat>
                            <v-toolbar-title class="my-list-title">Especializadas</v-toolbar-title>
                        </v-toolbar>
                        <v-list
                            subheader
                            dense
                            style="height: 341px; max-height:100%"
                            class="overflow-y-auto"
                            color="grey lighten-5"
                            :disabled="functionType !== '2'"
                        >
                            <v-list-item-group
                                v-model="selectedSpecializedValIndex"
                                color="orange accent-4"
                                mandatory
                            >
                                <v-list-item
                                    class="my-list-item"
                                    v-for="(funct, i) in specializedFunctionsValToShow"
                                    :key="i"
                                    @click="selectSpecialized(funct.funcionesid)"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <v-container pa-0 fluid>
                                                <v-layout row wrap>
                                                    <v-flex md2 xs6>{{ funct.funcion }}</v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-card>
                </v-flex>
                <v-flex xs4 md2>
                    <v-card>
                        <v-toolbar dense color="teal darken-1" dark flat>
                            <v-toolbar-title class="my-list-title">Desagregadas</v-toolbar-title>
                        </v-toolbar>
                        <v-list
                            subheader
                            dense
                            style="height: 341px; max-height:100%"
                            class="overflow-y-auto"
                            color="grey lighten-5"
                            :disabled="functionType !== '3'"
                        >
                            <v-list-item-group
                                v-model="selectedDisaggregatedValIndex"
                                color="orange accent-4"
                                mandatory
                            >
                                <v-list-item
                                    class="my-list-item"
                                    v-for="(funct, i) in disaggregatedFunctionsValToShow"
                                    :key="i"
                                    @click="selectDisaggregated(funct.funcionesid)"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <v-container pa-0 fluid>
                                                <v-layout row wrap>
                                                    <v-flex md2 xs6>{{ funct.funcion }}</v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-card>
                </v-flex>
                <v-flex xs12 md5>
                    <v-card color="grey lighten-5">
                        <v-toolbar dense color="teal lighten-3" flat>
                            <v-toolbar-title class="my-list-title">{{ selectedFunctionName }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon>assignment</v-icon>
                        </v-toolbar>

                        <v-card-text>
                            <v-container fluid>
                                <v-layout row wrap justify-space-between>
                                    <v-flex xs12>
                                        <v-text-field
                                            name="nombre"
                                            label="Función Primaria"
                                            type="text"
                                            v-model="primaryName"
                                            ref="primary_name"
                                            color="teal darken-3"
                                            readonly
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap justify-space-between>
                                    <v-flex xs12>
                                        <v-text-field
                                            name="nombre"
                                            label="Función Especializada"
                                            type="text"
                                            v-model="specializedName"
                                            ref="specialized_name"
                                            color="teal darken-3"
                                            readonly
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap justify-space-between>
                                    <v-flex xs12>
                                        <v-text-field
                                            name="nombre"
                                            label="Función Desagregada"
                                            type="text"
                                            v-model="disaggregatedName"
                                            ref="disaggregated_name"
                                            color="teal darken-3"
                                            readonly
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs4 sm3 md3>
                                        <v-text-field
                                            name="nombre"
                                            label="Contexto"
                                            v-model="context"
                                            ref="context_text_field"
                                            color="teal darken-3"
                                            reverse
                                            prefix="%"
                                            readonly
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs4 sm3 md3 offset-xs4 offset-sm3 offset-md2>
                                        <v-text-field
                                            name="nombre"
                                            label="Desafío"
                                            v-model="challenge"
                                            ref="challenge_text_field"
                                            color="teal darken-3"
                                            reverse
                                            prefix="%"
                                            readonly
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>

            <v-layout align-center justify-end row fill-height>
                <v-flex xs12 sm8 class="text-xs-center text-end">
                    <v-btn
                        color="teal darken-3"
                        class="text-none"
                        text
                        @click="onSelectFunction"
                    >Seleccionar Función</v-btn>
                    <v-btn color="pink darken-1" class="text-none" text @click="onClose">Cancelar</v-btn>
                </v-flex>
            </v-layout>
        </v-container>

        <!-- Fin container para toda la página ********************************************* -->
    </v-card>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'companyFunctions',
    data() {
        return {
            drawer: false,
            bNew: false,
            bInvalidData: false,
            errorMessage: '',
            functionID: 0,
            functionType: '1', //1 = primaria, 2 = especializada, 3 = desagregada.

            selectedPrimaryID: null,
            selectedSpecializedID: null,
            selectedDisaggregatedID: null,
            selectedParentID: null,
            selectedFunctionName: '',
            selectedType: 0, //Tipo de la función seleccionada.
            primaryName: '',
            specializedName: '',
            disaggregatedName: '',

            context: '',
            challenge: ''
        };
    },
    props: {
        companyID: Number,
        companyName: String
    },
    created() {
        this.selectFirstPrimary();
    },
    methods: {
        onSelectFunction() {
            console.log('onSelectFunction, this.functionID  ', this.functionID);
            if (this.functionID !== 0) {
                this.$store.dispatch('assignValFunction', this.functionID);

                //Para que si el usuario vuelve a entrar a este diálogo, esté seleccionada la primera
                //función primaria:
                this.onPrimaryFunctions();
                //this.selectFirstPrimary();
            }
        },
        selectFirstPrimary() {
            console.log('selectFirstPrimary()');
            if (this.primaryFunctionsVal.length > 0) {
                this.selectedPrimaryValIndex = 0;
                var primaryID = this.primaryFunctionsVal[
                    this.selectedPrimaryValIndex
                ].funcionesid;
                this.selectPrimary(primaryID);
            } else {
                this.selectedPrimaryValIndex = -1;
                //this.primaryID = 0;
            }
        },
        selectPrimary(functionID) {
            if (functionID !== null && functionID !== undefined) {
                //Se llenan campos de contexto y desafío.
                //Se hace un request de los hijos de la función seleccionada.
                //Si hay hijos, se habilita el radio "Especializadas"

                this.selectedPrimaryID = functionID;
                this.functionID = functionID;
                this.selectedType = 1;

                var i;
                for (i = 0; i < this.primaryFunctionsVal.length; i++) {
                    if (
                        this.primaryFunctionsVal[i].funcionesid === functionID
                    ) {
                        this.selectedFunctionName = this.primaryFunctionsVal[
                            i
                        ].funcion;
                        this.primaryName = this.primaryFunctionsVal[i].funcion;
                        this.specializedName = ' ';
                        this.disaggregatedName = ' ';
                        this.context = this.primaryFunctionsVal[i].contexto;
                        this.challenge = this.primaryFunctionsVal[i].desafio;

                        var funct = {
                            companyID: this.companyID,
                            dependencia: this.primaryFunctionsVal[i]
                                .funcionesid,
                            showFunctions: 0 //Indica si specializedFunctionsValToShow debe ser llenado.
                        };

                        this.$store.dispatch(
                            'fetchSpecializedFunctionsVal',
                            funct
                        );

                        break;
                    }
                }
            }
        },
        selectFirstSpecialized() {
            if (this.specializedFunctionsVal.length > 0) {
                this.selectedSpecializedValIndex = 0;
                var specializedID = this.specializedFunctionsVal[
                    this.selectedSpecializedValIndex
                ].funcionesid;
                this.selectSpecialized(specializedID);
            } else {
                this.selectedSpecializedValIndex = -1;
                this.specializedID = 0;
                this.onPrimaryFunctions();
            }
        },
        selectSpecialized(functionID) {
            if (functionID !== null && functionID !== undefined) {
                //Se llenan campos de contexto y desafío.
                //Se hace un request de los hijos de la función seleccionada.
                //Si hay hijos, se habilita el radio "Desagregadas"

                this.selectedSpecializedID = functionID;
                this.functionID = functionID;
                this.selectedType = 2;

                var i;
                for (i = 0; i < this.specializedFunctionsVal.length; i++) {
                    if (
                        this.specializedFunctionsVal[i].funcionesid ===
                        functionID
                    ) {
                        this.selectedFunctionName = this.specializedFunctionsVal[
                            i
                        ].funcion;
                        this.primaryName = this.specializedFunctionsVal[
                            i
                        ].funcionPrincipal.nombre;

                        this.specializedName = this.specializedFunctionsVal[
                            i
                        ].funcion;
                        this.disaggregatedName = ' ';
                        this.context = this.specializedFunctionsVal[i].contexto;
                        this.challenge = this.specializedFunctionsVal[
                            i
                        ].desafio;

                        var funct = {
                            companyID: this.companyID,
                            dependencia: this.specializedFunctionsVal[i]
                                .funcionesid,
                            showFunctions: 0 //Indica si disaggregatedFunctionsValToShow debe ser llenado.
                        };

                        this.$store.dispatch(
                            'fetchDisaggregatedFunctionsVal',
                            funct
                        );

                        break;
                    }
                }
            }
        },
        selectFirstDisaggregated() {
            if (this.disaggregatedFunctionsVal.length > 0) {
                console.log('disaggregatedFunctionsVal.length > 0...');
                this.selectedDisaggregatedValIndex = 0;
                var disaggregatedID = this.disaggregatedFunctionsVal[
                    this.selectedDisaggregatedValIndex
                ].funcionesid;
                this.selectDisaggregated(disaggregatedID);
            } else {
                console.log('disaggregatedFunctionsVal.length = 0...');
                this.selectedDisaggregatedValIndex = -1;
                this.disaggregatedID = 0;
                this.onSpecializedFunctions();
            }
        },
        selectDisaggregated(functionID) {
            if (functionID !== null && functionID !== undefined) {
                this.selectedDisaggregatedID = functionID;
                this.functionID = functionID;
                this.selectedType = 3;

                var i;
                for (i = 0; i < this.disaggregatedFunctionsVal.length; i++) {
                    if (
                        this.disaggregatedFunctionsVal[i].funcionesid ===
                        functionID
                    ) {
                        this.selectedFunctionName = this.disaggregatedFunctionsVal[
                            i
                        ].funcion;
                        this.primaryName = this.disaggregatedFunctionsVal[
                            i
                        ].funcionPrincipal.nombre;
                        this.specializedName = this.disaggregatedFunctionsVal[
                            i
                        ].funcionEspecializada.nombre;
                        this.disaggregatedName = this.disaggregatedFunctionsVal[
                            i
                        ].funcion;
                        this.context = this.disaggregatedFunctionsVal[
                            i
                        ].contexto;
                        this.challenge = this.disaggregatedFunctionsVal[
                            i
                        ].desafio;

                        break;
                    }
                }
            }
        },
        onPrimaryFunctions() {
            this.specializedFunctionsValToShow = [];
            this.disaggregatedFunctionsValToShow = [];
            this.selectedSpecializedID = null;
            this.selectedDisaggregatedID = null;

            this.selectPrimary(this.selectedPrimaryID);
        },
        onSpecializedFunctions() {
            this.specializedFunctionsValToShow = this.specializedFunctionsVal;
            this.disaggregatedFunctionsValToShow = [];
            this.selectedDisaggregatedID = null;

            if (
                this.selectedSpecializedID === null ||
                this.selectedSpecializedID === undefined
            ) {
                this.selectFirstSpecialized();
            } else {
                this.selectSpecialized(this.selectedSpecializedID);
            }
        },
        onDisaggregatedFunctions() {
            this.disaggregatedFunctionsValToShow = this.disaggregatedFunctionsVal;
            if (
                this.selectedDisaggregatedID === null ||
                this.selectedDisaggregatedID === undefined
            ) {
                this.selectFirstDisaggregated();
            } else {
                this.selectDisaggregated(this.selectedDisaggregatedID);
            }
        },
        onClose() {
            this.onPrimaryFunctions();
            //this.selectFirstPrimary();
            this.$store.dispatch('assignValFunction', null);
        }
    },
    computed: {
        ...mapGetters([
            'primaryFunctionsVal',
            'specializedFunctionsVal',
            'disaggregatedFunctionsVal',
            'thereAreSpecializedFunctionsVal',
            'thereAreDisaggregatedFunctionsVal',
            'waitCursor'
        ]),
        selectedPrimaryValIndex: {
            get() {
                return this.$store.getters.selectedPrimaryValIndex;
            },
            set(selectedPrimaryValIndex) {
                this.$store.dispatch(
                    'updateSelectedPrimaryValIndex',
                    selectedPrimaryValIndex
                );
            }
        },
        selectedSpecializedValIndex: {
            get() {
                return this.$store.getters.selectedSpecializedValIndex;
            },
            set(selectedSpecializedValIndex) {
                this.$store.dispatch(
                    'updateSelectedSpecializedValIndex',
                    selectedSpecializedValIndex
                );
            }
        },
        selectedDisaggregatedValIndex: {
            get() {
                return this.$store.getters.selectedDisaggregatedValIndex;
            },
            set(selectedDisaggregatedValIndex) {
                this.$store.dispatch(
                    'updateSelectedDisaggregatedValIndex',
                    selectedDisaggregatedValIndex
                );
            }
        },
        specializedFunctionsValToShow: {
            get() {
                return this.$store.getters.specializedFunctionsValToShow;
            },
            set(specializedFunctionsValToShow) {
                this.$store.dispatch(
                    'updateSpecializedFunctionsValToShow',
                    specializedFunctionsValToShow
                );
            }
        },
        disaggregatedFunctionsValToShow: {
            get() {
                return this.$store.getters.disaggregatedFunctionsValToShow;
            },
            set(disaggregatedFunctionsValToShow) {
                this.$store.dispatch(
                    'updateDisaggregatedFunctionsValToShow',
                    disaggregatedFunctionsValToShow
                );
            }
        },

        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '50%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '30%';
            }
            return width;
        }
    }
};
</script>

<style scoped>
.sub-window {
    background-color: #e0e0e0; /*grey lighten-2 */
}
.functions {
    background: url('../assets/photo-1499750310107-5fef28a66643.png');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}
.my-car-table {
    width: 100%;
}
</style>